import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadService {
  
  baseUrl = environment.baseUrl;

  lead_form: FormGroup = new FormGroup({
    id: new FormControl(null),
    callback_date: new FormControl('',Validators.required),
    contact_person: new FormControl('',Validators.required),
    business_name: new FormControl('',Validators.required),
    contact_number: new FormControl('',Validators.required),
    alt_contact_no: new FormControl(''),
    email: new FormControl('',Validators.required),
    address: new FormControl('',Validators.required),
    product: new FormControl('',Validators.required),
    quot_amt: new FormControl('',Validators.required),
    lead_source: new FormControl('',Validators.required),
    status: new FormControl('',Validators.required),
    lead_status: new FormControl('',Validators.required),
  });

  lead_tagging_data_form: FormGroup = new FormGroup({
    id: new FormControl(null),
    lead_id: new FormControl('',Validators.required),
    callback_date: new FormControl(''),
    tagging_type: new FormControl('',Validators.required),
    remarks: new FormControl('',Validators.required),
  });

  constructor(private http:HttpClient,
    private datePipe: DatePipe,) { }
  
  populateForm(lead_id)
  {
    let formData = {
      'id': '',
      'lead_id': lead_id,
      'callback_date': null,
      'tagging_type': null,
      'remarks': null
    };
    this.lead_tagging_data_form.setValue(formData);
  }

  get_site_leads() {
    return this.http.get(this.baseUrl + '/get_site_leads');  
  }

  get_lead_by_id(lead_id) {
    return this.http.get(this.baseUrl + '/get_lead_by_id/' + lead_id);  
  }

  get_lead_taggings(lead_id){
    return this.http.get(this.baseUrl + '/get_lead_taggings/' + lead_id); 
  }

  toggle_site_lead_status(lead_id){
    return this.http.get(this.baseUrl + '/toggle_site_leads_status/' + lead_id); 
  }

  insert_lead_details(formData: any)
  { 
    return this.http.post(this.baseUrl + '/create_lead',{
      callback_date : this.datePipe.transform(formData.callback_date, 'yyyy-MM-dd'),
      contact_person: formData.contact_person,
      business_name : formData.business_name,
      contact_number : formData.contact_number,
      alt_contact_no: formData.alt_contact_no,
      email : formData.email,
      address : formData.address,
      product: formData.product,
      quot_amt : formData.quot_amt,
      lead_source : formData.lead_source,
      status: formData.status,
      lead_status : formData.lead_status,  
    });
  }

  insert_lead_tagging_details(formData: any)
  { 
    return this.http.post(this.baseUrl + '/create_lead_tagging',{
      lead_id: formData.lead_id,
      tagging_type : formData.tagging_type,
      callback_date : this.datePipe.transform(formData.callback_date, 'yyyy-MM-dd'),
      remarks : formData.remarks,
      
    });
  }

  get_lead_binding_data() {
    return this.http.get(this.baseUrl + '/get_lead_binding_data');
  }

  get_lead_campaigns_by_site(siteId) {
    return this.http.get(this.baseUrl + '/get_lead_campaigns_by_site/'+ siteId);
  }

  importLeads(leadData:any){
    return this.http.post(this.baseUrl + '/import_leads',{
      campaign_id: leadData.campaign_id,
      site_id: leadData.site_id,
      campaign_name: leadData.campaign_name,
      lead_source: leadData.lead_source,
      target_url: leadData.target_url,
      csvLeadData: leadData.csvLeadData,
      csvLeadHeader: leadData.csvLeadHeader,
    });
  }

  searchLeads(searchFormData:any){
    return this.http.post(this.baseUrl + '/search_leads',{
      campaign_id: searchFormData.campaign_id,
      site_id: searchFormData.site_id
    });
  }

  sendMessage(sendMessageForm:any, leadList) {
    //console.log(searchData);
    var temp_id, gateway_id = null;
    if(sendMessageForm.reminder_type=='Email'){
      temp_id = sendMessageForm.email_temp;
      gateway_id = sendMessageForm.email_gateway;
    }
    else{
      temp_id = sendMessageForm.sms_temp;
      gateway_id = sendMessageForm.sms_gateway;
    }

    return this.http.post(this.baseUrl + '/send_message',{ 
      reminder_type: sendMessageForm.reminder_type,
      temp_id: temp_id,
      gateway_id: gateway_id,
      lead_list : leadList
    });
  }

}
